export default __webpack_public_path__ + "static/david-4e97a605cf9a489865b29c05cc37dbec.png";